import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: filter-type__wrapper;

  [target='card'],
  [target='switch-card'] {
    padding: ${theme.spacings.mega} 0;
    margin-bottom: ${theme.spacings.bit};

    & > div {
      overflow-y: hidden;
    }
  }

  [target='switch-card'] {
    & > div {
      padding: 0 ${theme.spacings.giga};
    }
  }
  
  ${theme.media.mega} {
    [target='card'] {
      & > div {
        padding: 0 ${theme.spacings.bit} 0 ${theme.spacings.mega};
        margin-bottom: ${theme.spacings.bit};
      }
    }

    [target='switch-card'] {
      & > div {
        padding: 0 ${theme.spacings.mega};
      }
    }
  }
`

const blackFridayWrapperStyles = ({
  theme,
  isBlackFriday
}: {
  theme: Theme['theme']
  isBlackFriday: boolean
}) =>
  isBlackFriday &&
  css`
    label: filter-type__wrapper--black-friday;

    [target='switch-card'] {
      background-color: ${theme.colors.n800};
      color: ${theme.colors.white};
    }
  `

const baseStyles = ({ theme }: Theme) => css`
  label: toggle-button;

  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  ${theme.media.giga} {
    width: auto;
  }
`

const fastDeliveryStyles = ({ theme }: Theme) => css`
  label: fast-delivery;

  display: flex;
  align-items: center;

  text-transform: capitalize;

  svg {
    width: 22px;
    height: 22px;

    margin: 0 ${theme.spacings.byte};
  }
`

export const SwitchFilter = styled('div')(baseStyles)
export const Wrapper = styled('div')(wrapperStyles, blackFridayWrapperStyles)
export const FastDelivery = styled('div')(fastDeliveryStyles)
